import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SolarService } from '../../services/solarservice.service';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { MessageError } from 'base-models';
import { MessagebarComponent } from 'basecomponents';


import { ActivatedRoute } from '@angular/router';
import { GlobalService } from '@solar/services/global.service';
import { AlertType } from 'base-models';
import { EditionEnum } from 'base-models';
import { Flight, Supervision} from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';
import { CustomValidators } from '@solar/components/customvalidators/custom-validators';

@Component({
  selector: 'app-flight-edit',
  templateUrl: './flight-edit.component.html',
  styleUrls: ['./flight-edit.component.scss']
})
export class FlightEditComponent implements OnInit, OnChanges {

  alertmessage: MessageError;
  submitted: boolean;
  loadinglist: boolean = false;
  myform: FormGroup;
  titlesub:string="";
  title:string="Edit Flight";

  uploadinfo:any;//object with needed info to upload files

  loadfilescomponentview:boolean=false;

  @Output() saveEvent = new EventEmitter<Flight>();
  @Input() flight: Flight;//null must be created by caller and set supervision id
  @Input() supervision: Supervision=new Supervision();
  editState:EditionEnum=EditionEnum.READ;
  @Input() ismodal: boolean =false;
  @ViewChild('frmsmessagebar') frmsmessagebar: MessagebarComponent;
  //@ViewChild('editform') public editform: NgForm;

  constructor(
    public dialog: MatDialog
    , public baseService: SolarService
    , private fb: FormBuilder
    ,public route: ActivatedRoute
    ,public globservice:GlobalService
  ) {
    
    this.createForm();
  }

  ngOnInit() {
/*     if (this.flight && this.flight.id){
      return;
    }
    const id = this.route.snapshot.paramMap.get('id');
    if (id){
         console.log("this.route.snapshot.paramMap.get('id');", id);
    this.getViewModel(id);
    }
    else{
      this.flight = new Flight();
      this.flight.name='';
      this.flight.info=new InfoFlight();
      this.setForm();
    } */
 
  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['Flight'];
    if ((typeChange && !typeChange.firstChange) && typeChange.previousValue == undefined) {
      this.editState=EditionEnum.EDIT;
      this.configureUI();
    }
  }

  configureUI(){
    if (this.editState===EditionEnum.EDIT){
      this.setForm();
      this.uploadinfo= {'Flight':this.flight.id,'userid':this.globservice.currentUserValue};
      //this.uishowloadbtn();
    }
    else{
      this.setForm();
    }
  }

  isvalid() {
    return this.myform.valid && !this.submitted;
  }

  getViewModel(id): void {
    if (!id){
      return;
    }
    this.loadinglist = true;
    this.baseService.flightGetById(id)
      .subscribe(resmodel => this.handleresult(resmodel));
  }
  handleresult(resmodel: any) {
    this.loadinglist = false;
    this.flight = resmodel;
    this.editState=EditionEnum.EDIT;
    this.setForm();
    this.configureUI();
  }

  createForm() {

/*       temperature_low: ['' , [CustomValidators.smallerThan("temperature_high")]],
      temperature_high: ['' ,[CustomValidators.greaterThan("temperature_low")]], */    
    this.myform = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)] ],
      offset_x: ['', [Validators.required] ],
      offset_y: ['', [Validators.required] ],
      offset_z: ['', [Validators.required] ],
      temperature_offset: ['' ],
      temperature_low: ['' , [CustomValidators.smallerThan("temperature_high")]],
      temperature_high: ['' ,[CustomValidators.greaterThan("temperature_low")]],
      offset_camera_yaw: ['', [Validators.required] ],
      offset_camera_pitch: ['', [Validators.required] ],
      offset_camera_roll: ['', [Validators.required] ], 
      //description: [''],
      //flightDate: [''],
    }
    ,{ validators: this.customValidatorForm() }
    );
/*     this.myform.get('temperature_low').valueChanges.subscribe(() => {
      this.myform.get('temperature_high').updateValueAndValidity();
    });
    this.myform.get('temperature_high').valueChanges.subscribe(() => {
      this.myform.get('temperature_low').updateValueAndValidity();
    }); */
    
  }
  customValidatorForm() {
    return (form: FormGroup) => {
      const clow=form.get('temperature_low').value;
      const chigh=form.get('temperature_high').value;
      if (clow==null || chigh==null){
        return null;
      }
      let error =null;
      if (clow>=chigh){
        error={ "smallerthan": true };
        form.get('temperature_low').setErrors({ "smallerthan": true }); //<--see the setErrors
        form.get('temperature_high').setErrors({ "greaterthan": true }); //<--see the setErrors        
      } else{
        form.get('temperature_low').setErrors(null); 
        form.get('temperature_high').setErrors(null); 
      } 

      return error;
    };
  }

  testgeterr(){
    let obj=this.myform.get('temperature_low');
    console.log(obj);
    return obj.errors;
  }

  setForm() {
    if (!this.flight) {
      return;
    }
    let temperature_offset=this.flight.info.temperature_offset;
    if (temperature_offset==null || temperature_offset== undefined){
      temperature_offset=0;
      this.flight.info.temperature_offset=0;
    }
    let temperature_low=this.flight.info.temperature_low;
    if (temperature_low==-9999 ){
      temperature_low=null;
    }    
    let temperature_high=this.flight.info.temperature_high;
    if (temperature_high==-9999 ){
      temperature_high=null;
    }     
    this.myform.reset({
      name: this.flight.name,
      flightDate:this.flight.info.flightDate ? this.flight.info.flightDate : new Date(),
      offset_x: this.flight.info.offset_x,
      offset_y: this.flight.info.offset_y,
      offset_z: this.flight.info.offset_z,
      temperature_offset: temperature_offset,
      temperature_low: temperature_low,
      temperature_high: temperature_high,
      offset_camera_yaw: this.flight.info.offset_camera_yaw,
      offset_camera_pitch: this.flight.info.offset_camera_pitch,
      offset_camera_roll: this.flight.info.offset_camera_roll  
    });
  }

    //function used by optionlist
    optionlist_comparesite(opt1: any, opt2: any) {
      let res=opt1 && opt2 ? opt1.id === opt2.id : opt1 === opt2;
      return res;
    }

  prepareSave(): any {
    //como ejemplo, en nuestro caso es el mismo objeto
    const formModel = this.myform.value;
    const cloneModel: Flight = new Flight();
    cloneModel.id=this.flight.id;
    if (!this.flight.id){
      //cloneModel.info.createddate=new Date();
      //cloneModel.info.created_by=this.globservice.currentUserValue.id;
    }
    console.log (formModel.site);
    cloneModel.id_supervision=this.flight.id_supervision;
    
    cloneModel.name = formModel.name;
    cloneModel.info.offset_x = formModel.offset_x;
    cloneModel.info.offset_y = formModel.offset_y;
    cloneModel.info.offset_z = formModel.offset_z;
    cloneModel.info.temperature_offset = formModel.temperature_offset;
    cloneModel.info.temperature_low=formModel.temperature_low==null ? -9999: formModel.temperature_low;
    cloneModel.info.temperature_high=formModel.temperature_high==null ? 9999: formModel.temperature_high;    
    cloneModel.info.offset_camera_yaw = formModel.offset_camera_yaw;
    cloneModel.info.offset_camera_pitch = formModel.offset_camera_pitch;
    cloneModel.info.offset_camera_roll = formModel.offset_camera_roll;    
    //cloneModel.description = ''+formModel.description;
    //cloneModel.info.updating_date=new Date();
    //cloneModel.info.updated_by=this.globservice.currentUserValue.id;
    //cloneModel.info.flightDate=formModel.flightDate;

    return cloneModel;
  }



  saveModel(value?: any) {
    this.submitted = true;
    this.loadinglist = true;
    this.alertmessage = null;

    try {
      console.log("Flight-Edit saveModel start", this.flight);
      const clonemodel = this.prepareSave();
      this.baseService.flightEditCreate(clonemodel)
        .subscribe((resmodel) => this.savehandleresult(resmodel,clonemodel), err => this.savehandleError(err)
        );
    } catch (error) {
      this.alertmessage = ErrorcontrolService.basichandleError("", error);
      this.submitted = false;
      this.loadinglist = false;
      console.log(error);
    }
  }

  savehandleresult(resultmodel: Flight,clonemodel:Flight) {
    console.log("flight saved", resultmodel);
    this.submitted = false;
    this.loadinglist = false;
    this.alertmessage = new MessageError(AlertType.Success,'Flight saved ');

    if (this.flight == null || !this.flight.id) {
      //creando
      this.flight = resultmodel;
      //this.globservice.navigateTo('solar/supervision-master/'+resultmodel.id);
    }
    else {
      //editando asignamos los valores que necesitamos, porque no sabemos si el servicio devuelve todo o solo lo que interesa.
      this.flight.name = resultmodel.name;
      //this.flight.description = resultmodel.description;
      this.flight.info = resultmodel.info;
      this.flight.id_supervision=resultmodel.id_supervision;
      //si hay otros campos que necesitamos actualizar hay que añadirlos aqui
      
    }

    this.saveEvent.next(this.flight);

  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loadinglist = false;
    this.alertmessage = ErrorcontrolService.basichandleError("Error saving. Message: ", err);
    console.error('An error occurred:', err.message);
  }

  uishowbtntoloadfiles:boolean=false;
  uishowloadfilescomponentview:boolean=false;
  addfilesshowhide(){
    this.uishowloadfilescomponentview=!this.uishowloadfilescomponentview;
  }


  public static openModalWithModel(dialog: MatDialog, entity2edit: Flight): MatDialogRef<FlightEditComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<FlightEditComponent>;
    dialogRef = dialog.open(FlightEditComponent, dialogConfig);
    dialogRef.componentInstance.flight=entity2edit;
    dialogRef.componentInstance.setForm();
    return dialogRef;
  }


}
